import styled from "styled-components";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import colors from "../../../styles/colors";
import { defaults } from "../../../styles";

export const Response = styled.div`
  display: flex;
  flex-direction: column;

  border: solid 2px ${colors.brownishGrey};
  background-color: #eceff1;
  padding: 10px;

  p {
    margin: 5px 0;
  }

  .name-container {
    display: flex;
    justify-content: space-between;
  }
`;

export const Container = styled.div`
  margin: 15px;
  display: flex;
  flex-direction: column;

  ${Response}:not(:last-child) {
    border-bottom: none;
  }
`;

export const Responses = styled.div`
  h6 {
    margin-top: 30px;
  }

  p.marginb {
    margin-bottom: 30px;
  }

  p.date {
    font-style: italic;
  }
`;

export const Collapse = styled(FaChevronUp).attrs({
  className: "icon-mv-expand-down"
})`
  cursor: pointer;
`;

export const Expand = styled(FaChevronDown).attrs({
  className: "icon-mv-expand-up"
})`
  cursor: pointer;
`;

export const Buttons = styled.div`
  margin-left: auto;
`;

export const Button = styled(defaults.Button)`
  margin: 0 5px;
  background: transparent;
  text-transform: initial;
  color: ${colors.blue};
  font-weight: normal;
`;
